import styled from '@emotion/styled'

export const MenuContainer = styled.nav`
  z-index: 999;
  @media (max-width: 768px) {
    position: fixed;
    width: 100%;
  }
`

export const NavBarContainer = styled.div`
  display: flex;
  position: absolute;
  top: 90px;
  left: 20px;

  hexa-v2-nav-bar::part(nav-bar) {
    box-shadow: var(--elevation-2);
    max-width: unset;
  }

  hexa-v2-nav-bar::part(collapse-btn-txt) {
    color: white;
  }

  @media (max-width: 768px) {
    top: 0px;
    left: 0px;
    hexa-v2-nav-bar::part(nav-bar) {
      border-radius: 0px;
      height: calc(100vh - 20px);
    }
  }
`
